import React, { useState } from 'react';
import bcrypt from 'bcryptjs';

import './Authorize.css'

const Authorize = ({ onAuth, password }) => {
    
    const [ state, setState ] = useState({ input: "" });

    const handleInputChange = (e) => {
        setState({ input: e.target.value });
    }

    const handleKeyPress = (e) => {
        e.key === 'Enter' && authorize();
    }

    const authorize = async () => {
        const res = await bcrypt.compare(state.input, password);
        onAuth(res);
    } 

    return (
        <div className="authorize-container">
            <div className="authorize">
                <input 
                    className="password" 
                    type="password" 
                    placeholder="Password"
                    onInput={handleInputChange}
                    onKeyPress={handleKeyPress}
                ></input>
                <button className="authorize-button" onClick={authorize}> 
                    Authorize 
                </button>
            </div>
        </div>
    )
}


export default Authorize;
 